module.exports = __webpack_public_path__ + "img/1762090144778-q1QPEax-.405b021a.png";